import React from "react";

import { Loader } from "../loader";

import styles from "./styles.modules.scss";

export const Loading = ({ light }: { light?: boolean }) => (
    <div className={`loading ${styles.loading}`}>
        <Loader light={light} />
    </div>
);
